import React from 'react';

import Modal from '../../../../../components/Modal';
import Anchor from '../../../../../components/link/Anchor';
import ExcelUploadForm from '../../../../../components/form/ExcelUploadForm';
import {
  PRODUCT_CATEGORY_LINK_BULK_MAX_FILE_SIZE_LABEL,
  PRODUCT_CATEGORY_LINK_BULK_MAX_ROWS,
  PRODUCT_CATEGORY_LINK_CSV_HEADER,
} from '../../../../../constants/service/app/productCategoryLinkBulkConstants';
import './ExcelBulkCategoryProductUploadModal.scss';

const ExcelBulkCategoryProductUploadModal = (props) => {
  const { isOpen, file, onSubmit, onChange, closeModal, downloadSample } = props;

  return (
    <Modal
      title="카테고리 상품 일괄 업로드"
      isOpen={isOpen}
      width={600}
      height={360}
      isFooter={true}
      okText="상품 일괄 업로드 처리"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="excel-bulk-category-product-upload-modal-wrap">
        <div className="excel-bulk-category-product-upload-title">
          <span className="guide">업로드할 CSV 파일을 선택해주세요</span>
          {/*
            헤더를 코드에서 통제해야 워커의 완전 일치 검증과 어긋나지 않아, 샘플을 클라이언트에서 만든다.
            href 없는 a 는 포커스를 받지 못하므로 role/tabIndex/키 핸들러로 키보드 접근을 보장한다.
          */}
          <Anchor
            className="template-download"
            text="CSV 업로드 샘플"
            isUnderLine={true}
            color="primary"
            role="button"
            tabIndex={0}
            onClick={() => downloadSample()}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                downloadSample();
              }
            }}
          />
        </div>

        <div className="excel-file-finder-section">
          <span className="file-name">{file ? file.name : ''}</span>
          <ExcelUploadForm onChange={(file) => onChange(file)} validExtension={['.csv']} />
        </div>

        <div className="excel-bulk-category-product-upload-info">
          <div>CSV 파일만 업로드 가능합니다. 엑셀로 작성 후 &quot;다른 이름으로 저장 → CSV UTF-8&quot;을 선택하세요.</div>
          <div>첫 행(헤더)은 &quot;{PRODUCT_CATEGORY_LINK_CSV_HEADER}&quot; 와 컬럼명·순서까지 정확히 일치해야 합니다.</div>
          <div>2차 카테고리 ID 는 비워둘 수 있습니다.</div>
          <div>
            한 번에 최대 <strong>{PRODUCT_CATEGORY_LINK_BULK_MAX_ROWS.toLocaleString()}</strong>행 /{' '}
            {PRODUCT_CATEGORY_LINK_BULK_MAX_FILE_SIZE_LABEL} 까지 업로드 가능합니다.
          </div>
          <div>업로드 후 처리 진행 상황은 목록 화면의 진행 카드에서 확인할 수 있습니다.</div>
        </div>
      </div>
    </Modal>
  );
};

export default ExcelBulkCategoryProductUploadModal;
